// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Epithalon 09.17.26" (15ca52c4-65b8-48f7-a2c8-d5ff78a9b62a). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiEpithalonAnswerField } from './questions';

export const mdiEpithalon: FormType<mdiEpithalonAnswerField> = {
  name: 'Epithalon',
  validityLength: 25,
  questions: [
    {
      key: 'mdiEpithalon_sex',
      next: {
        switch: [
          {
            condition: { 'mdiEpithalon_sex.female': true },
            key: 'mdiEpithalon_pregnancy'
          },
          {
            condition: { 'mdiEpithalon_pregnancy.yes': true },
            key: 'mdiEpithalon_wereSorryTreatmentNotMedically'
          }
        ],
        els: 'mdiEpithalon_importantClickAttachedLinkReview'
      }
    },
    {
      key: 'mdiEpithalon_pregnancy',
      next: {
        condition: { 'mdiEpithalon_pregnancy.yes': true },
        key: 'mdiEpithalon_wereSorryTreatmentNotMedically',
        els: 'mdiEpithalon_importantClickAttachedLinkReview'
      }
    },
    'mdiEpithalon_wereSorryTreatmentNotMedically',
    'mdiEpithalon_importantClickAttachedLinkReview',
    'mdiEpithalon_reasonInterestedPeptide',
    {
      key: 'mdiEpithalon_everUsedPeptideTherapiesPast',
      next: {
        condition: { 'mdiEpithalon_everUsedPeptideTherapiesPast.yes': true },
        key: 'mdiEpithalon_peptidesUsedPreviously',
        els: 'mdiEpithalon_everReactionSideEffectsPeptide'
      }
    },
    'mdiEpithalon_peptidesUsedPreviously',
    {
      key: 'mdiEpithalon_everReactionSideEffectsPeptide',
      next: {
        condition: { 'mdiEpithalon_everReactionSideEffectsPeptide.yes': true },
        key: 'mdiEpithalon_reactionSideEffect',
        els: 'mdiEpithalon_diagnosedRedFlagMedicalConditions'
      }
    },
    'mdiEpithalon_reactionSideEffect',
    'mdiEpithalon_diagnosedRedFlagMedicalConditions',
    'mdiEpithalon_confirmNotHistoryCancerKidney',
    'mdiEpithalon_takeRedFlagMedicationsSubstances',
    'mdiEpithalon_allergyBenzylPeroxide',
    'mdiEpithalon_lastTimePersonMedicalEvaluation',
    'mdiEpithalon_confirmUnderstandContactDoctorQuestions',
    'mdiEpithalon_firstMessageDoctor',
    'mdiEpithalon_complete'
  ]
};
